module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--space-video-settingsff2db9a886d3ee17c52fd2e1a82bfbb5.svg";